import { render, staticRenderFns } from "./pronunciationPopup.vue?vue&type=template&id=420a94f1&scoped=true&"
import script from "./pronunciationPopup.ts?vue&type=script&lang=js&"
export * from "./pronunciationPopup.ts?vue&type=script&lang=js&"
import style0 from "./pronunciationPopup.less?vue&type=style&index=0&id=420a94f1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "420a94f1",
  null
  
)

export default component.exports